module.exports = __webpack_public_path__ + "static/client_10_before-8ae807f44aebacb633132452b8021044.jpg";